import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';

export function ImgLazyload(props) {
    return (
        <LazyLoadImage  effect="blur" visibleByDefault={true} {...props} />
    )
}
